
/**
 * TODO: Delete it all later
 */

window.enableButton = function (button) {
    $(button).prop('disabled', false);
    $(button).removeClass('disabled');
}

window.disableButton = function (button) {
    $(button).prop('disabled', true);
    $(button).addClass('disabled');
}

window.toAbey = function (value) {
    if (value =="" || value == NaN || value == undefined || value < 0) {
        return 0;
    }

    let newValue = parseInt(value * 100000000) / 100000000;

    if (newValue == NaN || newValue < 0) {
        return 0;
    }
    return newValue;
}

window.sumAbey = function (value1, value2) {
    let newValue1 = parseInt(value1 * 100000000);
    let newValue2 = parseInt(value2 * 100000000);
    let newValue = (newValue1 + newValue2) / 100000000;

    if (newValue == NaN || newValue < 0) {
        return 0;
    }
    return newValue;
}

window.multiplyAbey = function (value1, value2) {
    let newValue1 = parseInt(value1 * 100000000);

    let newValue = (newValue1 * value2) / 100000000;

    if (newValue == NaN || newValue < 0) {
        return 0;
    }
    return newValue;
}

window.formatAbey = function (value1) {
    return value1.toString();
}

window.convertExponentialToDecimal = function(number) {
    // sanity check - is it exponential number
    const str = number.toString();
    if (str.indexOf('e') !== -1) {
        const exponent = parseInt(str.split('-')[1], 10);
        const result = number.toFixed(exponent);
        return result;
    } else {
        return number;
    }
}



window.setErrorOnField = function(fieldid, errorText) {
    try {
        $(fieldid+"_error").remove();

        let groupNode = $(fieldid).parent();
        groupNode.addClass("error");
        $(fieldid).focus();
        groupNode.append("<div class='error_text' id='"+fieldid.replace("#", "")+"_error'>"+errorText+"</div>");

        // let descrNode = groupNode.parent().parent().find(".form-control-descr");
        // descrNode.css({display: "none"});
    } catch (ee) {
        console.log(ee);
    }
}

window.removeError = function(fieldid) {
    try {
        $(fieldid + "_error").remove();

        let groupNode = $(fieldid).parent();
        groupNode.removeClass("error");
    } catch (ee) {
        console.log(ee);
    }
}


$(".copy-button").click(function(){
    try {
        $(this).tooltip('hide');

        let button = $(this);
        button.find('.balloon').addClass('balloon-show');
        let data = button.attr('data');
        navigator.clipboard.writeText(data);

        setTimeout(() => {
            button.find('.balloon').removeClass('balloon-show');
        }, 2000);
    } catch (ee) {
        console.log(ee);
    }
});
